import {
  CHURN_TYPE_LABELS,
  FINAL_USER_SIGNAL_LABELS,
  SESSION_END_STATE_LABELS,
} from '@/features/churn/churn-types';
import type { ChurnRecord } from '@/features/churn/churn-types';

function csvCell(value: string | number | boolean | null | undefined): string {
  if (value === null || value === undefined) return '';
  const text = String(value);
  if (/[",\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

function formatLabel(
  value: string | null | undefined,
  labels: Record<string, string>
): string {
  if (!value) return '';
  return labels[value] ?? value;
}

export function downloadChurnRecordsCsv(
  records: ChurnRecord[],
  runId: string
): void {
  const headers = [
    'user_email',
    'user_id',
    'churn_type',
    'plan_at_churn',
    'churn_month',
    'churn_date',
    'reason_submitted',
    'final_chat_id',
    'final_session_message_count',
    'final_session_downvoted',
    'days_from_last_message_to_churn',
    'label_status',
    'session_summary',
    'key_user_quotes',
    'task_category',
    'final_user_signal',
    'session_end_state',
  ];

  const rows = records.map((record) =>
    [
      record.user_email,
      record.user_id,
      CHURN_TYPE_LABELS[record.churn_type] ?? record.churn_type,
      record.plan_at_churn,
      record.churn_month,
      record.churn_date,
      record.reason_submitted,
      record.final_chat_id ?? '',
      record.final_session_message_count,
      record.final_session_downvoted,
      record.days_from_last_message_to_churn ?? '',
      record.label_status,
      record.session_summary ?? '',
      record.key_user_quotes.join(' | '),
      record.task_category ?? '',
      formatLabel(record.final_user_signal, FINAL_USER_SIGNAL_LABELS),
      formatLabel(record.session_end_state, SESSION_END_STATE_LABELS),
    ]
      .map(csvCell)
      .join(',')
  );

  const csv = [headers.join(','), ...rows].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `churn-analysis-${runId.slice(0, 8)}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}

export function formatChurnDate(iso: string): string {
  return new Date(iso).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatSignal(value: string | null): string {
  if (!value) return '—';
  return FINAL_USER_SIGNAL_LABELS[value] ?? value.replace(/_/g, ' ');
}

export function formatEndState(value: string | null): string {
  if (!value) return '—';
  return SESSION_END_STATE_LABELS[value] ?? value.replace(/_/g, ' ');
}
